import { notEmpty } from "@product/scmp-sdk";
import { useToggle } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { formatInTimeZone, toISOString } from "~/lib/utils";
import type { articleDateContent$key } from "~/queries/__generated__/articleDateContent.graphql";

import { PublishedDateContainer, StyledDiv, UpdatedDateContainer } from "./styles";

export type Props = {
  reference: articleDateContent$key;
};

export const ArticleDate: FunctionComponent<Props> = ({ reference: reference_, ...attribs }) => {
  const content = useFragment(
    graphql`
      fragment articleDateContent on Content {
        createdDate
        publishedDate
        updatedDate
      }
    `,
    reference_,
  );
  const [isToggle, setToggle] = useToggle(false);

  if (!content) return null;
  const dateFormat = "h:mmaaa, d MMM, yyyy";
  const { createdDate, updatedDate } = content;
  const publishedDate = notEmpty(content.publishedDate) ? content.publishedDate : createdDate;

  return (
    <StyledDiv onClick={setToggle} {...attribs}>
      <PublishedDateContainer $isToggle={isToggle}>
        <time dateTime={publishedDate ? toISOString(publishedDate) : undefined}>
          Published: {publishedDate && formatInTimeZone(publishedDate, dateFormat)}
        </time>
      </PublishedDateContainer>
      {isToggle && updatedDate && (
        <UpdatedDateContainer>
          <time dateTime={toISOString(updatedDate)}>
            Updated: {formatInTimeZone(updatedDate, dateFormat)}
          </time>
        </UpdatedDateContainer>
      )}
    </StyledDiv>
  );
};

ArticleDate.displayName = "ArticleDate";
